import React, { useState } from 'react';
import '../Static/dashboard.css';
import { Link } from 'react-router-dom';

const Dashboard = () => {

  const [formData, setFormData] = useState({
    textInput: '',
    dropdownInput: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleDropdownChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      dropdownInput: value
    });
  };


  // const item = [
  //   {
  //     icon: 'firm',
  //     title: 'Firm'
  //   },
  //   {
  //     icon: 'cloth',
  //     title: 'Cloth'
  //   },
  //   {
  //     icon: 'cut',
  //     title: 'Cutting'
  //   },
  //   {
  //     icon: 'items',
  //     title: ' Items'
  //   },
  //   {
  //     icon: 'kaja',
  //     title: 'Kaja'
  //   }
  // ];

  const item = [
    {
      icon: 'employee',
      title: 'Attendence'
    },
    {
      icon: 'cloth',
      title: 'Production'
    }
  ];
  return (
    <>

      {/* <div className="icon-container">
        {item.map((ele, index) => (
        
          <a href="">
            <div className="icon-card" key={index}>
              <img alt="icon" src={`/assets/icons/${ele.icon}.png`} />
              <div className="card-title">{ele.title}</div>
            </div>
          </a> 

        ))}
      </div> */}


      <div className="nav">
        <h2 className="nav-title">Tiyara Garment</h2>
      </div>

      <div className="icon-container">
        {item.map((ele, index) => (
          <div className="icon-card" key={index}>
            {ele.title === 'Attendence' ? (
              // If title is "Attendence", use a regular <a> tag to redirect to an external link
              <a href="https://piyara.smittech.in/attendance/index.php" target="" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000' }}>
                <img alt="icon" src={`/assets/icons/${ele.icon}.png`} />
                <div className="card-title">{ele.title}</div>
              </a>
            ) : (
              // If title is "Production", use <Link> from react-router-dom to navigate
              <Link to="/login-production" style={{ textDecoration: 'none', color: '#000' }}>
                <img alt="icon" src={`/assets/icons/${ele.icon}.png`} />
                <div className="card-title">{ele.title}</div>
              </Link>
            )}
          </div>
        ))}
      </div>


    </>
  );
}

export default Dashboard;

